import React from 'react'
import { ChevronRight, ChevronLeft } from "lucide-react"

const SelectBox = ({ secCode, companyName, selectedCompanies, onCompanyClick }) => {
    const isSelectedCompany = (selectedCompanies, secCode) => {
        if (selectedCompanies.some((company) => company.secCode == secCode)) {
            return true;
        } else {
            return false;
        }
    }

    return (
            <div 
            className={`rounded text-sm md:text rounded-full flex justify-center items-center p-[5px] w-[55px] md:w-[60px] h-[30px] cursor-pointer ${
                isSelectedCompany(selectedCompanies, secCode) ? "bg-gray-400 hover:bg-gray-500" : "target-company-unselected bg-gray-700 hover:bg-gray-600"
              }`}
              onClick={() => onCompanyClick(secCode, companyName)}
              >
                {isSelectedCompany(selectedCompanies, secCode) ? 
                    <>
                        <ChevronLeft className="w-4 h-4" style={{color: 'white'}} />
                        <div className='text-white'>戻す</div>
                    </>
                :
                    <>
                        <div className='text-white'>分析</div>
                        <ChevronRight className="w-4 h-4 " style={{color: 'white'}} />
                    </>
                }
            </div>
     )
}

export default SelectBox